// extracted by mini-css-extract-plugin
export default {"zoomModal":"n1-z","image":"o1-z","button":"p1-z","isOverlayShown":"q1-z"};